<template>
    <div class="content-container">
        <div class="content">
            <div class="container">
                <div class="row">

                    <!-- Title -->
                    <div class="col-12">
                        <div class="title">
                            <h1>{{ pageTitle }}</h1>
                        </div>
                    </div>

                    <div class="col-12" v-if="loadingAvailability">
                        <loading-state></loading-state>
                        <h4 class="text-center">Loading available dates, please wait...</h4>
                    </div>

                    <template v-if="!loadingAvailability">
                        <div class="col-12">
            <!--                <label>Here's the next available date:</label>-->
            <!--                <div class="card-list">-->
            <!--                    <div class="selectable-card active">-->
            <!--                        <div class="card-body justify-content-between">-->
            <!--                            <p>-->
            <!--                                {{ parseDayName(firstDate) }}-->
            <!--                            </p>-->
            <!--                            <p>-->
            <!--                                14:00 - 15:00-->
            <!--                            </p>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </div>-->

            <!--                <label>Other dates:</label>-->
                            <p class="text-muted text-sm">
                                <i class="fa fa-info-circle"></i> We send your time slot the day before your repair.
                            </p>

                            <div class="card-list scrollable">
                                <div class="selectable-card"
                                     @click="selectDay(day)"
                                     v-for="(day, timestamp) in filteredAvailabilities"
                                     :key="timestamp"
                                     :class="{ active : dayIsCurrentlySelected(day) }"
                                     :disabled="!day.available">
                                    <div class="card-body justify-content-between">
                                        <p>
                                            {{ parseDayName(day) }}
                                        </p>
                                        <p>
                                            {{ parseSlotsLeft(day) }}
                                        </p>
                                    </div>
                                </div>

                                <template v-if="displayLoadMoreButton">
                                    <button class="btn btn-outline-secondary btn-rounded btn-load-more btn-sm mt-1 mx-auto" @click="loadMoreAvailability()" v-if="!loadingMoreAvailability">
                                        Load more dates
                                    </button>
                                    <button class="btn btn-outline-secondary btn-rounded btn-load-more btn-sm mt-1 mx-auto disabled" @click="loadMoreAvailability()" v-if="loadingMoreAvailability">
                                        <span><i class="fa fa-spinner fa-pulse"></i></span> Loading dates
                                    </button>
                                </template>
                                <router-link v-if="showAlternativeBookingOptions && !showingAtLeastOneAvailableDayWithinDays" :to="{ name: 'repairOptionsExternal'}" class="text-sm text-center">Pick an alternative repair option</router-link>
                            </div>
                        </div>
                        <!-- Footer -->
                        <footer class="footer" :class="footerClass" v-if="!loadingAvailability">
                            <div class="container">
                                <router-link :to="{ name: previousStep}" class="btn btn-outline-secondary back-btn btn-lg"><i class="fa fa-chevron-left text-sm mr-3"></i> Back</router-link>
                                <router-link :to="{ name: nextStep}" class="btn btn-primary btn-lg continue-btn icon-right ml-auto" :class="{'disabled': !booking.date}">Next <i class="fa fa-chevron-right ml-3 text-sm"></i></router-link>
                            </div>
                        </footer>
                    </template>
                </div>

            </div>
        </div>

        <!-- No dates available modal -->
        <no-dates-available-modal></no-dates-available-modal>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import moment from 'moment';

    export default {
        name: "SelectDate",

        mounted() {
            this.checkCanBeOnPage();

            if (!this.showingAtLeastOneAvailableDay) {
                this.initiateLoadAvailability(null, 6);
            }
            if (this.carrierDetails.additionalLandingPage) {
                this.showAlternativeBookingOptions = true;
                if (this.carrierDetails.additionalLandingPageLimit) {
                   this.showAlternativeBookingOptionDayLimit = this.carrierDetails.additionalLandingPageLimit;
                }
            }
        },

        data() {
            return  {
                loadingAvailability: false,
                loadingMoreAvailability: false,
                reloadsCompleted: 0,
                showAlternativeBookingOptions: false,
                showAlternativeBookingOptionDayLimit: 7,
            }
        },

        computed: {
            ...mapGetters([
                'allowsStoreDropOff',
                'availabilities',
                'booking',
                'carrierDetails',
                'hasAvailability',
                'hasDevices',
                'isBookingInStore',
                'inWarrantyStatus',
                'isApplianceRepair'
            ]),

            displayLoadMoreButton() {
                if (!this.inWarrantyStatus) return true;

                return !this.showingAtLeastOneAvailableDay;
            },

            footerClass() {
                return (window.innerHeight < 768) ? "fixed-footer" : "";
            },

            pageTitle() {
                let repairType = (this.isApplianceRepair) ? 'appliance' : 'device';

                if (this.isBookingInStore) {
                    return `When would you like us to repair the ${repairType}?`;
                }

                return `When would you like us to repair your ${repairType}?`;
            },

            previousStep() {
                if (this.allowsStoreDropOff && this.isBookingInStore) {
                // if (this.allowsStoreDropOff) {
                    return 'repairOptions';
                }
                return 'basket';
            },

            nextStep() {
                return 'repairLocation';
            },

            filteredAvailabilities() {
                let self = this;
                return Object.keys(this.availabilities).reduce(function(r, e) {
                    r[e] = self.availabilities[e];
                    return r;
                }, {})
            },

            showingAtLeastOneAvailableDay() {
                let weAreShowingAnAvailableDay = false;
                for (let key in this.availabilities) {
                    if (!Object.prototype.hasOwnProperty.call(this.availabilities, key)) continue;

                    if (this.availabilities[key].available) {
                        weAreShowingAnAvailableDay = true;
                    }
                }
                return weAreShowingAnAvailableDay;
            },
            showingAtLeastOneAvailableDayWithinDays() {
                let showingAtLeastOneAvailableDayWithinDays = false;
                // Check when the 3 or 7 dat limit is, from now.
                let endDate = moment().add(this.showAlternativeBookingOptionDayLimit, 'day');
                for (let key in this.availabilities) {
                    if (!Object.prototype.hasOwnProperty.call(this.availabilities, key)) continue;

                    // If there is an availability, and it is equal to or before the end date, we return true.
                    if (this.availabilities[key].available && moment(key, 'YYYY-MM-DD').isSameOrBefore(endDate)) {
                        showingAtLeastOneAvailableDayWithinDays = true;
                    }
                }

                return showingAtLeastOneAvailableDayWithinDays;
            },
        },

        methods: {
            ...mapActions([
                'checkBookingIsComplete',
                'loadAvailability',
                'setDate',
                'displayToastFromResponseObjectOfErrors'
            ]),

            addDaysToDate(datetime, days) {
                datetime.setDate(datetime.getDate() + days);
                return datetime;
            },

            checkCanBeOnPage() {
                this.checkBookingIsComplete().then(() => {
                    if (!this.hasDevices) {
                        this.$router.push({name: 'basket'});
                    }
                });
            },

            dayIsCurrentlySelected(day) {
                if (!this.booking.date) return false;
                return (day.date === this.booking.date);
            },

            initiateLoadAvailability(startDate, days) {
                this.loadingAvailability = true;

                this.loadAvailability({ startDate: startDate, daysToLoad: days })
                    .then(() => {
                        this.loadingAvailability = false;
                    }).catch(() => {
                        this.loadingAvailability = false;
                    });
            },

            loadMoreAvailability() {
                // if (this.inWarrantyStatus) {
                //     this.$bvModal.show('no-dates-available-modal');
                //     return;
                // }

                this.reloadsCompleted++;

                let lastDay = this.availabilities[Object.keys(this.availabilities)[Object.keys(this.availabilities).length - 1]];
                let start = new Date(lastDay.date);
                start = this.addDaysToDate(start, 1);

                this.loadingMoreAvailability = true;

                this.loadAvailability({ startDate: start, daysToLoad: 5 })
                    .then(() => {
                        this.loadingMoreAvailability = false;

                        if (!this.showingAtLeastOneAvailableDay && this.reloadsCompleted < 6) {
                            this.loadMoreAvailability();
                        }

                    }).catch(() => {
                        this.loadingMoreAvailability = false;
                    });
            },

            parseDayName(day) {
                return (day.is_tomorrow) ? 'Tomorrow' : `${day.week_day_full} ${day.full_date}`;
            },

            parseSlotsLeft(day) {
                if (!day.available) return 'Fully Booked';

                return "Available";

                // if (day.number_of_slots_left > 4) return 'Available';

                // let text = `Only ${day.number_of_slots_left} slot`;

                // if (day.number_of_slots_left > 1) {
                //     return text += 's';
                // }
                // return text += ' left';
            },

            selectDay(day) {
                if (!day.available || day.date === this.booking.date) return;
                this.setDate(day.date).catch(errors => this.displayToastFromResponseObjectOfErrors(errors));
            }
        }
    }
</script>

<style scoped>

</style>